import { useTranslations } from 'next-intl';
import type { FC } from 'react';
import { useMemo } from 'react';
import { BaseLinePause } from '@/app/components/icons/BaseLinePause';
import { BaseLinePlay } from '@/app/components/icons/BaseLinePlay';
import { IMG_DEFAULT } from '@/app/constants';
import { useAudioPlay } from '@/app/hooks';
import type { AudioOption } from '@/app/types';
import { cn } from '@/app/utils';
import { useLocale } from '@/i18n/routing';

export const DisplaySelectedAudioItem: FC<{ audio: AudioOption; className?: string; audioList?: AudioOption[] }> = ({
  audio,
  className,
  audioList,
}) => {
  const t = useTranslations();
  const locale = useLocale();
  const currentAudio = useMemo(() => {
    const timbre = audioList?.find((item) => item.id === audio.id);
    return timbre
      ? {
          img: timbre.img,
          id: timbre.id,
          name: audio.name || timbre.name,
          url: audio.url || timbre.url,
        }
      : audio;
  }, [audio, locale]);
  const { isPlaying, handlePlayPause } = useAudioPlay({ url: currentAudio.url || '', id: currentAudio.id || '' });
  return (
    <div className={cn('flex items-center justify-center gap-2 bg-[#3E4451] px-1 py-1 pr-3 text-white', className)}>
      {
        // id有值 显示图片
        currentAudio.id ? (
          <img
            src={currentAudio.img || IMG_DEFAULT}
            alt={currentAudio.name}
            className={cn(
              'h-[18px] w-[18px] flex-shrink-0 rounded-full',
              isPlaying ? 'animate-[spin_4s_linear_infinite]' : 'transition-transform duration-300',
            )}
          />
        ) : (
          <div />
        )
      }
      <div className="flex-1 text-xs">{currentAudio.name || t('elements.elementDialog.noSound')}</div>
      {currentAudio.url && (
        <div
          className="flex-shrink-0 cursor-pointer"
          onPointerDown={(e) => {
            // 在 pointerdown 阶段就阻止事件冒泡，防止 Select 关闭
            e.stopPropagation();
          }}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            handlePlayPause();
          }}
        >
          {isPlaying ? <BaseLinePause className="size-3" /> : <BaseLinePlay className="size-3" />}
        </div>
      )}
    </div>
  );
};
